export const isFirefox =
  navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
